import { JobComment } from '../jobComment';


export class JobCommentSerializer {
    fromJson(json: any): JobComment {

        const data = new JobComment();
        data.id = json.id;
        data.name = json.name;
        data.description=json.description,
        data.job=json.jobId,
        data.createdBy=json.createdBy,
        data.updatedOn=json.updatedOn
        return data;
    }

    toJson(data: JobComment): any {
  
        return {
            id: data.id,
            name: data.name,
            description: data.description,
            job: data.job,
            createdBy :data.createdBy
        };
    }
}